module.exports = __webpack_public_path__ + "static/media/noun-coffee-machine-2913373-808080.e71ef7b0.svg";